module.exports = __webpack_public_path__ + "img/1477141333.c3e527a0.jpg";